export default __webpack_public_path__ + "static/media/KafkaConnect.5fccd396.md";